// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import Footer from "./Footer";
// import Navbar from "./Navbar";

// const sections = [
//   {
//     number: "1",
//     title: "Acceptance of Terms",
//     content: `These Terms and Conditions ("Terms", "Agreement") constitute a legally binding contract between you ("User", "you", "your") and Furbabies Inc., a Delaware C-corporation with its principal place of business at 495 Grand Blvd #206, Miramar Beach, FL 32550 ("Furbabies", "we", "us", "our"), governing your access to and use of the Furbabies.AI platform, website, mobile applications, and all associated services, features, and content (collectively, the "Service").

// By clicking "I Agree," registering for an account, uploading content, or otherwise using the Service, you expressly acknowledge that you have read, understood, and agree to be bound by these Terms, our Privacy Policy, and our Cookie Policy, each of which is incorporated herein by reference. If you do not agree to these Terms in their entirety, you must immediately cease all use of the Service.

// These Terms apply to users worldwide. The Service is offered in English, Mandarin Chinese, Spanish, Hindi, French, Arabic, Farsi, Bengali, Russian, Portuguese, Urdu, and Telugu. In the event of any conflict between translated versions and the English version of these Terms, the English version shall govern and control.`,
//   },
//   {
//     number: "2",
//     title: "Description of Service",
//     subsections: [
//       {
//         title: "2.1 Nature of Service",
//         content: `Furbabies.AI is an artificial intelligence-powered pet care information platform designed to help pet owners better understand their pets' health and nutritional needs. The Service provides:

// • Pet Health Triage Assistance: Users may upload photos and videos of their pets to receive AI-generated informational guidance on observed conditions, including but not limited to skin conditions, itching, rashes, coat appearance, fecal presentation, and general physical appearance.

// • Nutrition Guidance: Users may upload images of food products, ingredient labels, and nutritional labels to receive AI-generated information about the suitability of such items for their registered pet(s).

// • AI Chatbot (Furbot): An AI-powered conversational assistant that answers general pet care and nutrition questions.

// • Educational Content: General information designed to help pet owners make informed decisions about at-home care and determine when professional veterinary attention may be warranted.`,
//       },
//       {
//         title: "2.2 NOT Veterinary Services",
//         content: `THE SERVICE DOES NOT CONSTITUTE VETERINARY MEDICINE, VETERINARY ADVICE, VETERINARY DIAGNOSIS, OR VETERINARY TREATMENT OF ANY KIND. Furbabies.AI is an informational and educational tool only. The Service is expressly designed to assist users in triaging their pets' needs by helping them distinguish between situations that may be managed at home with proper care and those that may require professional veterinary evaluation.

// No veterinarian-client-patient relationship is created by your use of this Service. No licensed veterinarian reviews your submissions in real time. AI-generated outputs are not a substitute for the professional judgment of a licensed veterinarian. ALWAYS CONSULT A LICENSED VETERINARIAN FOR DIAGNOSIS, TREATMENT, OR ANY MEDICAL CONCERN REGARDING YOUR PET.`,
//         highlight: true,
//       },
//     ],
//   },
//   {
//     number: "3",
//     title: "Eligibility and Account Registration",
//     subsections: [
//       {
//         title: "3.1 Eligibility",
//         content: `The Service is available to individuals who are at least 18 years of age and possess the legal capacity to enter into binding contracts. By using the Service, you represent and warrant that you meet these eligibility requirements and that all information you provide is accurate, current, and complete.`,
//       },
//       {
//         title: "3.2 Registration",
//         content: `To access the Service, you must register for an account by providing accurate and complete information, including your name, email address, valid payment information (processed through Stripe, Inc.), and details about your pet(s). You agree to maintain and promptly update your account information to keep it accurate and current.

// You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately at social@furbabies.ai of any unauthorized use of your account.`,
//       },
//       {
//         title: "3.3 Pet Registration",
//         content: `As part of the registration process, you will provide information about your pet(s), which may include species, breed, age, weight, sex, and other relevant characteristics. This information is used to personalize the Service's AI-generated guidance. You represent that all pet information provided is accurate to the best of your knowledge.`,
//       },
//     ],
//   },
//   {
//     number: "4",
//     title: "Subscription, Fees, and Payment",
//     subsections: [
//       {
//         title: "4.1 Free Trial",
//         content: `New users are entitled to a thirty (30) day free trial period commencing on the date of registration. No charges will be incurred during the free trial period.`,
//       },
//       {
//         title: "4.2 Subscription Fee",
//         content: `Following the expiration of the free trial period, your subscription will automatically convert to a paid subscription at a rate of $9.95 USD per month ("Subscription Fee"), billed monthly to the payment method provided at registration.`,
//       },
//       {
//         title: "4.3 Payment Processing",
//         content: `All payments are processed by Stripe, Inc., a third-party payment processor. By providing your payment information, you authorize Furbabies to charge your designated payment method on a recurring monthly basis. You agree to Stripe's terms of service, which govern all payment transactions. Furbabies does not store your full credit card number; payment data is handled exclusively by Stripe in accordance with PCI-DSS compliance standards.`,
//       },
//       {
//        title: "4.4 Cancellation",
// content: `You may cancel your subscription at any time by logging into your account, navigating to Account > Manage Subscription, and cancelling directly through the Stripe customer portal. Cancellation takes effect at the end of the then-current billing cycle. No refunds are provided for partial months of service. Following cancellation, you will retain access to the Service until the end of your prepaid billing period.`,
//       },
//       {
//         title: "4.5 Price Changes",
//         content: `Furbabies reserves the right to modify the Subscription Fee upon thirty (30) days prior written notice to the email address associated with your account. Continued use of the Service following the effective date of a price change constitutes your acceptance of the new pricing.`,
//       },
//     ],
//   },
//   {
//     number: "5",
//     title: "User Conduct and Acceptable Use",
//     subsections: [
//       {
//         title: "5.1 Permitted Use",
//         content: `You may use the Service solely for lawful, personal, non-commercial purposes in accordance with these Terms. You agree that you will use the Service only for your own pet(s) or pets in your lawful care.`,
//       },
//       {
//         title: "5.2 Prohibited Conduct",
//         content: `You agree that you will NOT:

// • Upload, transmit, or share content that is false, misleading, fraudulent, or deceptive.
// • Upload images or videos of animals depicting abuse, cruelty, neglect, or illegal activity.
// • Use the Service for any commercial purpose without our prior written consent.
// • Attempt to reverse engineer, decompile, or extract the underlying AI models, algorithms, or datasets used in the Service.
// • Use automated bots, scrapers, crawlers, or other automated means to access or collect data from the Service.
// • Violate any applicable local, state, national, or international law or regulation.
// • Impersonate any person or entity, or falsely represent your affiliation with any person or entity.
// • Attempt to circumvent any security measures or access controls of the Service.
// • Upload any malware, viruses, or other harmful code.
// • Use the Service in any manner that could damage, disable, overburden, or impair the Service's infrastructure.`,
//       },
//     ],
//   },
//   {
//     number: "6",
//     title: "Content Uploads and Intellectual Property",
//     subsections: [
//       {
//         title: "6.1 Your Content",
//         content: `You retain ownership of any photos, videos, and other content you upload to the Service ("User Content"). By uploading User Content, you grant Furbabies a worldwide, non-exclusive, royalty-free, perpetual, irrevocable, sublicensable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such User Content for research, development, service improvement, and commercial purposes.`,
//       },
//       {
//         title: "6.2 Research and Commercial Use of Data",
//         content: `You expressly acknowledge and agree that Furbabies stores all chats, uploaded photos, uploaded videos, and associated metadata for research and commercial purposes. This data may be used to train, improve, and develop AI models and services, subject to applicable privacy laws. Furbabies will handle such data in accordance with its Privacy Policy.`,
//       },
//       {
//         title: "6.3 Furbabies Intellectual Property",
//         content: `The Service, including its AI models, algorithms, software, design, trademarks, service marks, logos, and all content created by Furbabies ("Furbabies Content"), is the exclusive property of Furbabies or its licensors and is protected by copyright, trademark, patent, and other intellectual property laws. You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the Service for personal, non-commercial purposes only.`,
//       },
//     ],
//   },
//   {
//     number: "7",
//     title: "Disclaimer of Warranties — Limitation of Liability — Release",
//     subsections: [
//       {
//         title: "7.1 Disclaimer of Warranties",
//         content: `THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY, RELIABILITY, OR COMPLETENESS. FURBABIES DOES NOT WARRANT THAT: (A) THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE; (B) ANY AI-GENERATED OUTPUTS WILL BE ACCURATE, COMPLETE, OR APPROPRIATE FOR YOUR PET'S SPECIFIC CIRCUMSTANCES; (C) DEFECTS WILL BE CORRECTED; OR (D) THE SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.

// AI-GENERATED INFORMATION IS PROBABILISTIC IN NATURE AND MAY BE INCORRECT, INCOMPLETE, OR OUTDATED. YOU ASSUME ALL RISKS ASSOCIATED WITH RELIANCE ON AI-GENERATED CONTENT.`,
//         highlight: true,
//       },
//       {
//         title: "7.2 Limitation of Liability",
//         content: `TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, FURBABIES, ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, LICENSORS, AFFILIATES, AND SUCCESSORS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES; LOSS OF PROFITS, REVENUE, DATA, BUSINESS, GOODWILL, OR ANTICIPATED SAVINGS; PERSONAL INJURY TO OR DEATH OF ANY PET OR PERSON; VETERINARY COSTS, MEDICAL COSTS, OR ANY EXPENSES INCURRED IN CONNECTION WITH PET CARE; OR DAMAGES RESULTING FROM RELIANCE ON AI-GENERATED OUTPUTS, FURBOT RESPONSES, OR ANY CONTENT PROVIDED THROUGH THE SERVICE.

// IN NO EVENT SHALL FURBABIES'S TOTAL CUMULATIVE LIABILITY TO YOU EXCEED THE GREATER OF (A) THE TOTAL SUBSCRIPTION FEES YOU PAID TO FURBABIES IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR (B) FIFTY U.S. DOLLARS ($50.00).`,
//         highlight: true,
//       },
//       {
//         title: "7.3 Complete Release of Liability",
//         content: `BY USING THE SERVICE, YOU HEREBY FULLY, FINALLY, AND UNCONDITIONALLY RELEASE, DISCHARGE, AND FOREVER HOLD HARMLESS FURBABIES INC., ITS PARENT COMPANIES, SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, SHAREHOLDERS, MEMBERS, EMPLOYEES, CONTRACTORS, AGENTS, LICENSORS, SERVICE PROVIDERS, AND ALL OF THEIR RESPECTIVE HEIRS, SUCCESSORS, AND ASSIGNS FROM ANY AND ALL CLAIMS, DEMANDS, ACTIONS, CAUSES OF ACTION, SUITS, PROCEEDINGS, LOSSES, DAMAGES, COSTS, EXPENSES (INCLUDING ATTORNEYS' FEES), LIABILITIES, AND OBLIGATIONS OF EVERY KIND AND NATURE, WHETHER KNOWN OR UNKNOWN.

// IF YOU ARE A CALIFORNIA RESIDENT, YOU EXPRESSLY WAIVE ANY RIGHTS YOU MAY HAVE UNDER CALIFORNIA CIVIL CODE SECTION 1542.`,
//         highlight: true,
//       },
//       {
//         title: "7.4 Indemnification",
//         content: `You agree to indemnify, defend, and hold harmless the Released Parties from and against any and all third-party claims, liabilities, losses, damages, costs, and expenses (including reasonable attorneys' fees) arising from or related to: (a) your use of the Service; (b) any User Content you upload; (c) your violation of these Terms; (d) your violation of any third party's rights; or (e) your violation of any applicable law.`,
//       },
//     ],
//   },
//   {
//     number: "8",
//     title: "Privacy and Data Practices",
//     content: `Your use of the Service is governed by our Privacy Policy, which is incorporated herein by reference. By using the Service, you consent to the collection, use, and sharing of your data as described in the Privacy Policy.

// You expressly acknowledge that Furbabies stores all uploaded photos, videos, chats, and interaction data for research and commercial purposes as described in the Privacy Policy. The Service complies with applicable data protection laws including GDPR, CCPA/CPRA, LGPD, PIPEDA, PDPA, and other applicable international privacy regulations to the extent required by law.`,
//   },
//   {
//     number: "9",
//     title: "Third-Party Services",
//     content: `The Service integrates with and relies upon third-party services, including Stripe for payment processing and various AI model providers. Your use of third-party services is subject to their respective terms of service and privacy policies. Furbabies is not responsible for the practices of any third-party services. Furbabies does not endorse any third-party products, services, or websites linked from the Service.`,
//   },
//   {
//     number: "10",
//     title: "Modifications to the Service and Terms",
//     content: `Furbabies reserves the right to modify, suspend, or discontinue the Service (or any portion thereof) at any time, with or without notice. Furbabies may also update these Terms from time to time. We will provide notice of material changes by posting the updated Terms on the Service and updating the "Last Updated" date. Your continued use of the Service following notice of changes constitutes your acceptance of the revised Terms.`,
//   },
//   {
//     number: "11",
//     title: "Termination",
//     content: `Furbabies reserves the right to suspend or terminate your account and access to the Service at any time, with or without cause, upon notice to you. Grounds for termination include, without limitation, violation of these Terms, fraudulent conduct, abusive behavior, or conduct harmful to other users or the Service. Upon termination, all licenses granted to you hereunder shall immediately terminate. Sections 6, 7, 8, 12, and 13 shall survive termination.`,
//   },
//   {
//     number: "12",
//     title: "Dispute Resolution and Governing Law",
//     subsections: [
//       {
//         title: "12.1 Governing Law",
//         content: `These Terms shall be governed by and construed in accordance with the laws of the State of Florida, United States of America, without regard to its conflict of laws principles.`,
//       },
//       {
//         title: "12.2 Mandatory Arbitration",
//         content: `ANY DISPUTE, CLAIM, OR CONTROVERSY ARISING OUT OF OR RELATING TO THESE TERMS OR YOUR USE OF THE SERVICE SHALL BE RESOLVED EXCLUSIVELY THROUGH BINDING INDIVIDUAL ARBITRATION administered by JAMS under its Streamlined Arbitration Rules, except that either party may bring individual claims in small claims court. YOU WAIVE ANY RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.`,
//         highlight: true,
//       },
//       {
//         title: "12.3 Venue",
//         content: `For any matters not subject to arbitration, you consent to the exclusive jurisdiction of the state and federal courts located in Okaloosa County, Florida, USA.`,
//       },
//       {
//         title: "12.4 International Users",
//         content: `Furbabies operates from the United States. Users accessing the Service from outside the United States do so at their own risk and are responsible for compliance with local laws.`,
//       },
//     ],
//   },
//   {
//     number: "13",
//     title: "General Provisions",
//     subsections: [
//       { title: "13.1 Entire Agreement", content: `These Terms, together with the Privacy Policy and Cookie Policy, constitute the entire agreement between you and Furbabies concerning the Service and supersede all prior agreements, representations, and understandings.` },
//       { title: "13.2 Severability", content: `If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue in full force and effect.` },
//       { title: "13.3 Waiver", content: `Failure by Furbabies to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.` },
//       { title: "13.4 Assignment", content: `You may not assign these Terms or any rights hereunder without Furbabies's prior written consent. Furbabies may assign these Terms freely.` },
//       { title: "13.5 Social Impact Commitment", content: `Furbabies donates one percent (1%) of its profits to Humane World for Animals in furtherance of its mission to promote animal welfare. This commitment does not create any third-party beneficiary rights.` },
//       { title: "13.6 Contact Information", content: `For questions about these Terms, please contact us at: Furbabies Inc., 495 Grand Blvd #206, Miramar Beach, FL 32550, or by email at social@furbabies.ai.` },
//     ],
//   },
// ];

// const SectionBlock = ({ section, index }) => {
//   const [open, setOpen] = useState(true);

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       transition={{ duration: 0.5, delay: index * 0.05 }}
//       className="mb-4 rounded-2xl overflow-hidden border  border-[#e8ddd6]"
//     >
//       {/* Section header */}
//       <button
//         onClick={() => setOpen(!open)}
//         className="w-full flex items-center justify-between px-6 py-4 bg-[#f4ede7] hover:bg-[#ede4db] transition-colors text-left"
//       >
//         <div className="flex items-center  gap-4">
//           <span className="w-8 h-8 rounded-full bg-[#967d6c] text-white text-sm font-bold flex items-center justify-center flex-shrink-0">
//             {section.number}
//           </span>
//           <h2 className="text-lg font-bold text-gray-800">{section.title}</h2>
//         </div>
//         <span className={`text-[#967d6c] text-xl transition-transform duration-200 ${open ? "rotate-180" : ""}`}>
//           ▾
//         </span>
//       </button>

//       {open && (
//         <div className="px-6 py-5 bg-white">
//           {section.content && (
//             <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{section.content}</p>
//           )}
//           {section.subsections && section.subsections.map((sub, i) => (
//             <div key={i} className={`mb-5 last:mb-0 ${sub.highlight ? "bg-[#fdf8f5] border-l-4 border-[#967d6c] pl-4 pr-3 py-3 rounded-r-xl" : ""}`}>
//               <h3 className="text-sm font-bold text-gray-800 mb-2">{sub.title}</h3>
//               <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{sub.content}</p>
//             </div>
//           ))}
//         </div>
//       )}
//     </motion.div>
//   );
// };

// const TermsAndConditions = () => {
//   return (
//     <>
//       <Helmet>
//         <title>Terms and Conditions — Furbabies.AI</title>
//         <meta name="description" content="Read the Furbabies.AI Terms and Conditions of Service." />
//       </Helmet>

//       <Navbar />

//       <div className="min-h-screen bg-white pt-28 pb-16">
//         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

//           {/* Header */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7 }}
//             className="mb-12 text-center mt-20"
//           >
//             <p className="text-[#967d6c] font-semibold poppins-text text-sm uppercase tracking-widest mb-3">Legal</p>
//             <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 mb-4">
//               Terms & Conditions
//             </h1>
//             <p className="poppins-text text-gray-500 text-sm">
//               Effective Date: March 10, 2026 &nbsp;·&nbsp; Last Updated: March 10, 2026
//             </p>
//             <div className="mt-4 inline-block bg-[#fdf8f5] border border-[#e8ddd6] rounded-full px-5 py-2">
//               <p className="text-xs poppins-text text-gray-500">
//                 Furbabies Inc. · 495 Grand Blvd #206, Miramar Beach, FL 32550 ·{" "}
//                 <a href="mailto:social@furbabies.ai" className="text-[#967d6c] hover:underline">social@furbabies.ai</a>
//               </p>
//             </div>
//           </motion.div>

//           {/* Intro notice */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.3, duration: 0.6 }}
//             className="mb-8 bg-[#967d6c] text-white rounded-2xl px-6 py-5"
//           >
//             <p className="text-sm font-semibold leading-7">
//               PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THE FURBABIES.AI SERVICE.
//               BY REGISTERING FOR, ACCESSING, OR USING THIS SERVICE, YOU AGREE TO BE BOUND BY THESE TERMS.
//             </p>
//           </motion.div>

//           {/* Sections */}
//           {sections.map((section, i) => (
//             <SectionBlock key={i} section={section} index={i} />
//           ))}

//           {/* Related links */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4"
//           >
//             {[
//               { label: "Privacy Policy", to: "/privacy-policy", desc: "How we collect and use your data" },
//               { label: "Cookie Policy", to: "/cookie-policy", desc: "How we use cookies and tracking" },
//             ].map((item) => (
//               <Link key={item.to} to={item.to}
//                 className="flex items-center justify-between bg-[#f4ede7] hover:bg-[#ede4db] transition-colors rounded-2xl px-6 py-4 group">
//                 <div>
//                   <p className="font-bold text-gray-800 text-sm">{item.label}</p>
//                   <p className="text-xs text-gray-500 poppins-text mt-0.5">{item.desc}</p>
//                 </div>
//                 <span className="text-[#967d6c] text-lg group-hover:translate-x-1 transition-transform">→</span>
//               </Link>
//             ))}
//           </motion.div>

//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default TermsAndConditions;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from "./Footer";
import Navbar from "./Navbar";

const sections = [
  {
    number: "1",
    title: "Acceptance of Terms",
    content: `These Terms and Conditions ("Terms", "Agreement") constitute a legally binding contract between you ("User", "you", "your") and Furbabies Inc., a Delaware C-corporation with its principal place of business at 495 Grand Blvd #206, Miramar Beach, FL 32550 ("Furbabies", "we", "us", "our"), governing your access to and use of the Furbabies.AI platform, website, mobile applications, and all associated services, features, and content (collectively, the "Service").

By clicking "I Agree," registering for an account, uploading content, or otherwise using the Service, you expressly acknowledge that you have read, understood, and agree to be bound by these Terms, our Privacy Policy, and our Cookie Policy, each of which is incorporated herein by reference. If you do not agree to these Terms in their entirety, you must immediately cease all use of the Service.

These Terms apply to users worldwide. The Service is offered in English, Mandarin Chinese, Spanish, Hindi, French, Arabic, Farsi, Bengali, Russian, Portuguese, Urdu, and Telugu. In the event of any conflict between translated versions and the English version of these Terms, the English version shall govern and control.

Your continued use of the Service at any time constitutes renewed and ongoing acceptance of these Terms as they exist at that time, including any amendments.`,
  },
  {
    number: "2",
    title: "Description of Service",
    subsections: [
      {
        title: "2.1 Nature of Service",
        content: `Furbabies.AI is an artificial intelligence-powered pet care information platform designed to help pet owners better understand their pets' health and nutritional needs. The Service provides:

• Pet Health Triage Assistance: Users may upload photos and videos of their pets to receive AI-generated informational guidance on observed conditions, including but not limited to skin conditions, itching, rashes, coat appearance, fecal presentation, and general physical appearance.

• Nutrition Guidance: Users may upload images of food products, ingredient labels, and nutritional labels to receive AI-generated information about the suitability of such items for their registered pet(s).

• AI Chatbot (Furbot): An AI-powered conversational assistant that answers general pet care and nutrition questions.

• Educational Content: General information designed to help pet owners make informed decisions about at-home care and determine when professional veterinary attention may be warranted.`,
      },
      {
        title: "2.2 NOT Veterinary Services",
        content: `THE SERVICE DOES NOT CONSTITUTE VETERINARY MEDICINE, VETERINARY ADVICE, VETERINARY DIAGNOSIS, OR VETERINARY TREATMENT OF ANY KIND. Furbabies.AI is an informational and educational tool only.

No veterinarian-client-patient relationship is created by your use of this Service. No licensed veterinarian reviews your submissions in real time. AI-generated outputs are not a substitute for the professional judgment of a licensed veterinarian. ALWAYS CONSULT A LICENSED VETERINARIAN FOR DIAGNOSIS, TREATMENT, OR ANY MEDICAL CONCERN REGARDING YOUR PET.`,
        highlight: true,
      },
      {
        title: "2.3 AI Limitations and No Accuracy Guarantee",
        content: `YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT:

• AI-generated outputs are probabilistic in nature and may be inaccurate, incomplete, outdated, or inappropriate for your specific situation.
• The Service does not have access to your pet's full medical history, physical examination findings, or laboratory results.
• AI outputs may reflect biases present in training data and are not peer-reviewed.
• The Service may not identify emergencies, life-threatening conditions, or situations requiring immediate care.
• Furbabies makes no representation that the Service is suitable for your pet's specific breed, age, health status, or circumstances.

RELIANCE ON AI-GENERATED OUTPUTS IS ENTIRELY AT YOUR OWN RISK. NEVER DELAY SEEKING EMERGENCY VETERINARY CARE BASED ON AI-GENERATED INFORMATION.`,
        highlight: true,
      },
      {
        title: "2.4 Geographic Availability",
        content: `The Service is made available globally but may not be appropriate or legally available in all jurisdictions. If you access the Service from a location where its use is prohibited by law, you do so at your own risk and are solely responsible for compliance with local laws. Furbabies makes no representation that the Service or its content is appropriate for use in any particular jurisdiction.`,
      },
    ],
  },
  {
    number: "3",
    title: "Eligibility, Age Requirements, and Account Registration",
    highlight_section: true,
    subsections: [
      {
        title: "3.1 Minimum Age Requirement — 18 Years or Older",
        content: `THE SERVICE IS STRICTLY INTENDED FOR USERS WHO ARE 18 YEARS OF AGE OR OLDER. BY ACCESSING OR USING THE SERVICE IN ANY MANNER, YOU REPRESENT AND WARRANT THAT YOU ARE AT LEAST 18 YEARS OF AGE.

If you are under 18 years of age, you are expressly prohibited from:
• Creating or registering an account on the Service;
• Accessing or using any feature of the Service;
• Submitting any personal information, photos, videos, or other content;
• Subscribing to or purchasing any paid tier of the Service.

Furbabies does not knowingly collect, solicit, or process personal information from individuals under 18. If we discover a user is under 18, we will immediately suspend and terminate the account, delete all associated data, and issue a full refund of any subscription fees paid.

If you are a parent or guardian and believe your child under 18 has registered for or is using the Service, contact us immediately at social@furbabies.ai.`,
        highlight: true,
      },
      {
        title: "3.2 Age Verification Rights",
        content: `By registering, you affirmatively confirm you are at least 18. Furbabies reserves the right, in its sole discretion, to request proof of age from any user at any time. Acceptable verification may include government-issued photo identification.

Failure to provide satisfactory verification, or any misrepresentation of age, constitutes a material breach of these Terms and will result in immediate termination without refund. Misrepresenting your age may expose you to legal liability under applicable laws including COPPA and GDPR Article 8.`,
        highlight: true,
      },
      {
        title: "3.3 COPPA and International Child Protection Compliance",
        content: `The Service is not directed at children under 13. Furbabies strictly complies with the Children's Online Privacy Protection Act (COPPA) and equivalent international regulations. We do not knowingly collect personal information from any person under 13.

For jurisdictions where the age of digital consent or contractual capacity exceeds 18, the higher threshold applies. You are responsible for determining the applicable minimum age in your jurisdiction.

Applicable child protection laws we comply with include: COPPA (US), GDPR Article 8 (EU/EEA), UK GDPR (United Kingdom), PIPEDA (Canada), and PDPA (Thailand).`,
      },
      {
        title: "3.4 General Eligibility",
        content: `In addition to the age requirement, the Service is available only to individuals with full legal capacity to enter binding contracts. You may not use the Service if: (a) you are prohibited under applicable laws; (b) Furbabies has previously terminated your account for cause; (c) you are located in a sanctioned jurisdiction; or (d) you are acting as agent for a person who does not meet these requirements.`,
      },
      {
        title: "3.5 Account Security and Sole Responsibility",
        content: `You are solely responsible for: (a) maintaining the confidentiality of your login credentials; (b) all activity under your account, authorized or unauthorized; (c) promptly notifying us of suspected unauthorized access at social@furbabies.ai; and (d) ensuring no one under 18 accesses the Service through your account.

You may not share your account with any other person. Furbabies will not be liable for any loss arising from your failure to protect your credentials.`,
      },
      {
        title: "3.6 Pet Registration",
        content: `You represent that you are the lawful owner or custodian of all pet(s) registered on the Service and that all pet information provided is accurate to the best of your knowledge. You may not register pets that are not under your lawful care or ownership.`,
      },
    ],
  },
  {
    number: "4",
    title: "Subscription, Fees, and Payment",
    subsections: [
      {
        title: "4.1 Free Trial",
        content: `New users are entitled to a thirty (30) day free trial commencing on registration. No charges will be incurred during the trial period. Furbabies reserves the right to modify or discontinue the free trial offer at any time without notice to prospective users.`,
      },
      {
        title: "4.2 Subscription Fee and Auto-Renewal",
        content: `Following the free trial, your subscription will automatically convert to a paid subscription at $9.95 USD per month, billed monthly. YOUR SUBSCRIPTION WILL AUTOMATICALLY RENEW EACH MONTH UNLESS YOU CANCEL BEFORE THE END OF THE THEN-CURRENT BILLING PERIOD. By providing payment information, you expressly authorize recurring charges.`,
        highlight: true,
      },
      {
        title: "4.3 Payment Processing and Failed Payments",
        content: `All payments are processed by Stripe, Inc. Furbabies does not store full credit card numbers; payment data is handled by Stripe under PCI-DSS compliance. If a payment fails, Furbabies may retry the charge, suspend your account, or terminate your subscription. You are responsible for keeping payment information current.`,
      },
      {
        title: "4.4 Cancellation and Refund Policy",
        content: `You may cancel via Account > Manage Subscription through the Stripe portal at any time. Cancellation takes effect at end of the current billing cycle. NO REFUNDS ARE PROVIDED FOR PARTIAL MONTHS OR UNUSED PERIODS, EXCEPT AS REQUIRED BY APPLICABLE LAW.

Exceptions: (a) accounts terminated due to discovered underage users will receive a full refund; (b) refunds mandated by consumer protection law in your jurisdiction will be honored.`,
      },
      {
        title: "4.5 Price Changes",
        content: `Furbabies may modify pricing with thirty (30) days' written notice to your registered email. Continued use after the effective date constitutes acceptance. If you do not accept a price change, cancel before the effective date.`,
      },
      {
        title: "4.6 Taxes",
        content: `Subscription fees are exclusive of all applicable taxes, levies, and duties. You are responsible for all such taxes except where Furbabies is legally required to collect and remit them on your behalf.`,
      },
    ],
  },
  {
    number: "5",
    title: "User Conduct and Acceptable Use",
    subsections: [
      {
        title: "5.1 Permitted Use",
        content: `You may use the Service solely for lawful, personal, non-commercial purposes in accordance with these Terms, and only for your own pet(s) or pets in your lawful care.`,
      },
      {
        title: "5.2 Prohibited Conduct",
        content: `You expressly agree that you will NOT:

• Upload content that is false, misleading, fraudulent, or deceptive.
• Upload content depicting animal abuse, cruelty, neglect, or illegal activity.
• Use the Service for commercial purposes without prior written consent.
• Attempt to reverse engineer, decompile, or extract underlying AI models or datasets.
• Use automated bots, scrapers, or crawlers to access the Service.
• Violate any applicable local, state, national, or international law.
• Impersonate any person or entity or falsely represent your affiliation.
• Circumvent any security measures or access controls.
• Upload malware, viruses, or other harmful code.
• Use the Service in any manner that could damage, disable, or impair it.
• Allow any person under 18 to access the Service through your account.
• Use the Service in jurisdictions where prohibited by law.
• Harvest or collect personal information about other users without consent.
• Submit false or fabricated pet information to manipulate AI outputs.
• Use the Service in emergency situations in lieu of contacting a veterinarian.`,
      },
      {
        title: "5.3 Emergency Situations — Critical Notice",
        content: `THE SERVICE IS NOT AN EMERGENCY SERVICE AND CANNOT BE USED AS A SUBSTITUTE FOR EMERGENCY VETERINARY CARE.

IF YOUR PET IS EXPERIENCING A MEDICAL EMERGENCY, DO NOT USE THIS APP. Contact an emergency veterinarian or animal emergency clinic immediately.

Signs that may indicate a pet emergency include but are not limited to: difficulty breathing, collapse, uncontrolled bleeding, suspected poisoning, seizures, inability to urinate, pale or white gums, or loss of consciousness.

FURBABIES EXPRESSLY DISCLAIMS ALL LIABILITY FOR ANY HARM OR DEATH TO ANY ANIMAL RESULTING FROM USE OF THE SERVICE IN AN EMERGENCY SITUATION OR FROM ANY DELAY IN SEEKING EMERGENCY VETERINARY CARE.`,
        highlight: true,
      },
    ],
  },
  {
    number: "6",
    title: "Content Uploads and Intellectual Property",
    subsections: [
      {
        title: "6.1 Your Content and License Grant",
        content: `You retain ownership of any content you upload ("User Content"). By uploading, you grant Furbabies a worldwide, non-exclusive, royalty-free, perpetual, irrevocable, sublicensable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such content for research, development, and commercial purposes.

You represent and warrant that: (a) you own or have all necessary rights to your User Content; (b) your content does not infringe any third-party rights; (c) you have obtained all necessary consents from any identifiable individuals appearing in your content; and (d) your content does not contain images of minors.`,
      },
      {
        title: "6.2 Research and Commercial Data Use",
        content: `You expressly acknowledge that Furbabies stores all chats, photos, videos, and metadata for research and commercial purposes including AI model training. De-identified or aggregated data may be used for research publications, commercial AI development, and sharing with third-party research partners. Data may be retained indefinitely subject to your rights under our Privacy Policy.`,
      },
      {
        title: "6.3 Content Restrictions",
        content: `You must not upload content that: (a) contains images of humans, particularly minors; (b) contains personally identifiable information of third parties without consent; (c) depicts illegal activity; (d) infringes third-party intellectual property; or (e) contains nudity or sexually explicit material.

Furbabies reserves the right to remove any User Content violating these restrictions at any time without notice and without liability.`,
      },
      {
        title: "6.4 Furbabies Intellectual Property",
        content: `The Service and all Furbabies-created content — including AI models, algorithms, software, design, trademarks, logos — is the exclusive property of Furbabies or its licensors, protected by copyright, trademark, patent, and other IP laws. You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the Service for personal, non-commercial purposes only.`,
      },
    ],
  },
  {
    number: "7",
    title: "Disclaimer of Warranties — Limitation of Liability — Release",
    subsections: [
      {
        title: "7.1 Disclaimer of Warranties",
        content: `THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND. FURBABIES DOES NOT WARRANT THAT: (A) THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE; (B) AI-GENERATED OUTPUTS WILL BE ACCURATE, COMPLETE, OR APPROPRIATE; (C) DEFECTS WILL BE CORRECTED; OR (D) THE SERVICE IS FREE OF VIRUSES OR HARMFUL COMPONENTS.

AI-GENERATED INFORMATION MAY BE INCORRECT, INCOMPLETE, OR OUTDATED. YOU ASSUME ALL RISKS ASSOCIATED WITH RELIANCE ON AI-GENERATED CONTENT.`,
        highlight: true,
      },
      {
        title: "7.2 Limitation of Liability",
        content: `TO THE MAXIMUM EXTENT PERMITTED BY LAW, FURBABIES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES; LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL; PERSONAL INJURY TO OR DEATH OF ANY PET OR PERSON; VETERINARY OR MEDICAL COSTS; OR DAMAGES FROM RELIANCE ON AI-GENERATED OUTPUTS OR FURBOT RESPONSES.

IN NO EVENT SHALL FURBABIES'S TOTAL LIABILITY EXCEED THE GREATER OF (A) SUBSCRIPTION FEES PAID IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR (B) FIFTY U.S. DOLLARS ($50.00).`,
        highlight: true,
      },
      {
        title: "7.3 Consequential Pet Harm Disclaimer",
        content: `FURBABIES EXPRESSLY DISCLAIMS ALL LIABILITY FOR ANY HARM, INJURY, ILLNESS, DEATH, OR ADVERSE OUTCOME TO ANY ANIMAL ARISING FROM USE OF OR RELIANCE ON THE SERVICE, AI-GENERATED OUTPUTS, OR FURBOT RESPONSES. This disclaimer applies regardless of theory of liability including negligence or strict liability. The entire risk of any action taken or not taken in reliance on the Service is borne by you.`,
        highlight: true,
      },
      {
        title: "7.4 Complete Release of Liability",
        content: `BY USING THE SERVICE, YOU HEREBY FULLY, FINALLY, AND UNCONDITIONALLY RELEASE, DISCHARGE, AND HOLD HARMLESS FURBABIES INC., ITS SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, LICENSORS, AND THEIR RESPECTIVE SUCCESSORS AND ASSIGNS FROM ANY AND ALL CLAIMS, DEMANDS, LOSSES, DAMAGES, COSTS, AND EXPENSES OF EVERY KIND AND NATURE, WHETHER KNOWN OR UNKNOWN.

CALIFORNIA RESIDENTS EXPRESSLY WAIVE CALIFORNIA CIVIL CODE SECTION 1542.`,
        highlight: true,
      },
      {
        title: "7.5 Indemnification",
        content: `You agree to indemnify and hold harmless Furbabies from and against all third-party claims, liabilities, losses, damages, costs, and expenses (including attorneys' fees) arising from: (a) your use of the Service; (b) your User Content; (c) your violation of these Terms; (d) your violation of any third party's rights; (e) your violation of any law; (f) any access to the Service by a minor facilitated by you; or (g) any harm to any animal resulting from your reliance on the Service.`,
      },
    ],
  },
  {
    number: "8",
    title: "Privacy, Data Practices, and AI Data Use",
    content: `Your use of the Service is governed by our Privacy Policy, incorporated herein by reference. By using the Service, you consent to the collection, use, and sharing of your data as described therein.

You expressly acknowledge that: (a) Furbabies stores all uploaded photos, videos, chats, and interaction data for research and commercial purposes; (b) AI outputs generated from your submissions may be used to improve the Service; (c) anonymized or de-identified data may be shared with research partners; (d) data may be transferred to and processed in the United States and other countries; and (e) you may request deletion subject to lawful retention requirements.

Consistent with our child safety commitment, Furbabies does not knowingly collect, retain, or process personal data from individuals under 18. Any such data identified will be promptly deleted.`,
  },
  {
    number: "9",
    title: "Third-Party Services and Links",
    content: `The Service integrates with third-party services including Stripe and AI model providers. Use of third-party services is governed by their respective terms and privacy policies. Furbabies is not responsible for third-party practices.

The Service may contain links to third-party websites for convenience only. Furbabies has no control over and assumes no responsibility for linked sites. Access to linked sites is at your own risk.

FURBABIES DOES NOT RECOMMEND AND IS NOT RESPONSIBLE FOR ANY THIRD-PARTY VETERINARY, NUTRITIONAL, OR PET HEALTH PRODUCTS OR SERVICES REFERENCED IN AI-GENERATED OUTPUTS.`,
  },
  {
    number: "10",
    title: "Modifications to the Service and Terms",
    content: `Furbabies may modify, suspend, or discontinue the Service at any time without liability. These Terms may be updated from time to time. Material changes will be communicated via the Service and by email where practicable. Continued use after changes constitutes acceptance of revised Terms. If you do not accept a modification, you must stop using the Service and cancel your subscription before the effective date.`,
  },
  {
    number: "11",
    title: "Termination and Suspension",
    subsections: [
      {
        title: "11.1 Termination by Furbabies",
        content: `Furbabies may suspend or terminate your account at any time with or without cause. Grounds include: violation of these Terms; fraudulent conduct; abusive behavior; misrepresentation of age or identity; uploading prohibited content; conduct harmful to users, animals, or the Service; or use posing legal risk to Furbabies. No refund will be issued for termination for cause.`,
      },
      {
        title: "11.2 Termination by You",
        content: `You may terminate your account by cancelling your subscription through the Stripe portal and contacting social@furbabies.ai to request deletion. Account deletion is subject to our data retention obligations.`,
      },
      {
        title: "11.3 Effect of Termination",
        content: `Upon termination, all licenses granted hereunder immediately terminate and you must cease all use of the Service. Sections 6, 7, 8, 12, and 13 survive termination. Termination does not relieve you of obligations incurred prior to termination.`,
      },
    ],
  },
  {
    number: "12",
    title: "Dispute Resolution and Governing Law",
    subsections: [
      {
        title: "12.1 Governing Law",
        content: `These Terms are governed by the laws of the State of Florida, United States, without regard to conflict of laws principles.`,
      },
      {
        title: "12.2 Informal Resolution First",
        content: `Before initiating any formal dispute, you agree to contact social@furbabies.ai and attempt informal resolution. We will make reasonable efforts to resolve disputes within thirty (30) days. This is a condition precedent to any formal proceeding.`,
      },
      {
        title: "12.3 Mandatory Arbitration and Class Action Waiver",
        content: `ANY DISPUTE ARISING OUT OF OR RELATING TO THESE TERMS OR THE SERVICE SHALL BE RESOLVED EXCLUSIVELY THROUGH BINDING INDIVIDUAL ARBITRATION administered by JAMS under its Streamlined Arbitration Rules, except that either party may bring individual claims in small claims court.

YOU WAIVE ANY RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE ARBITRATION. IF THIS WAIVER IS FOUND UNENFORCEABLE, THAT CLAIM SHALL PROCEED IN COURT, NOT IN ARBITRATION.`,
        highlight: true,
      },
      {
        title: "12.4 One-Year Limitation Period",
        content: `ANY CLAIM OR CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICE OR THESE TERMS MUST BE FILED WITHIN ONE (1) YEAR AFTER SUCH CLAIM AROSE. CLAIMS FILED AFTER THIS PERIOD ARE PERMANENTLY BARRED, REGARDLESS OF ANY STATUTE OF LIMITATIONS TO THE CONTRARY.`,
        highlight: true,
      },
      {
        title: "12.5 Venue",
        content: `For matters not subject to arbitration, you consent to the exclusive jurisdiction of state and federal courts in Okaloosa County, Florida, USA.`,
      },
      {
        title: "12.6 International Users",
        content: `Furbabies operates from the United States. International users access the Service at their own risk and are responsible for local law compliance. Nothing herein constitutes submission to non-U.S. court jurisdiction.`,
      },
    ],
  },
  {
    number: "13",
    title: "General Provisions",
    subsections: [
      { title: "13.1 Entire Agreement", content: `These Terms, together with the Privacy Policy and Cookie Policy, constitute the entire agreement between you and Furbabies and supersede all prior agreements, representations, and understandings.` },
      { title: "13.2 Severability", content: `If any provision is found invalid, illegal, or unenforceable, it shall be modified to the minimum extent necessary to make it enforceable. All remaining provisions continue in full force.` },
      { title: "13.3 Waiver", content: `Failure to enforce any provision does not constitute a waiver. Any waiver must be in writing signed by an authorized representative of Furbabies.` },
      { title: "13.4 Assignment", content: `You may not assign these Terms without prior written consent. Any attempted assignment in violation of this provision is void. Furbabies may assign freely, including in connection with a merger or sale of assets.` },
      { title: "13.5 Force Majeure", content: `Furbabies shall not be liable for any delay or failure resulting from causes beyond its reasonable control, including acts of God, natural disasters, war, pandemics, governmental actions, internet outages, cyberattacks, or third-party service failures.` },
      { title: "13.6 No Third-Party Beneficiaries", content: `These Terms are for the sole benefit of you and Furbabies. No third-party beneficiary rights are created except as expressly provided.` },
      { title: "13.7 Headings", content: `Section headings are for convenience only and shall not affect interpretation of any provision.` },
      { title: "13.8 Social Impact Commitment", content: `Furbabies donates 1% of profits to Humane World for Animals. This commitment does not create third-party beneficiary rights or contractual obligations.` },
      { title: "13.9 Contact Information", content: `For questions about these Terms, to report an underage user, or to request deletion of data associated with a minor:\n\nFurbabies Inc.\n495 Grand Blvd #206, Miramar Beach, FL 32550\nEmail: social@furbabies.ai` },
    ],
  },
];

const AgeBadge = () => (
  <span style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:99, background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.30)", fontSize:10, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#dc2626", marginLeft:10, flexShrink:0 }}>⚠ Age-Restricted</span>
);
const CriticalBadge = () => (
  <span style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:99, background:"rgba(245,158,11,0.10)", border:"1px solid rgba(245,158,11,0.35)", fontSize:10, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#d97706", marginLeft:10, flexShrink:0 }}>⚡ Critical</span>
);

const SectionBlock = ({ section, index }) => {
  const [open, setOpen] = useState(true);
  const isAge      = section.number === "3";
  const isLiability= section.number === "7";

  const headerBg    = isAge ? "linear-gradient(135deg,#fff5f5,#fef2f2)" : "#f4ede7";
  const headerHover = isAge ? "linear-gradient(135deg,#fee2e2,#fef2f2)" : "#ede4db";
  const borderCol   = isAge ? "rgba(220,38,38,0.35)" : "#e8ddd6";
  const shadow      = isAge ? "0 0 0 3px rgba(220,38,38,0.06)" : "none";
  const numBg       = isAge ? "#dc2626" : "#967d6c";
  const chevronCol  = isAge ? "#dc2626" : "#967d6c";

  return (
    <motion.div
      initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}
      transition={{ duration:0.5, delay: index * 0.04 }}
      className="mb-4 rounded-2xl overflow-hidden"
      style={{ border:`1.5px solid ${borderCol}`, boxShadow:shadow }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-6 py-4 text-left transition-colors"
        style={{ background: headerBg }}
        onMouseEnter={e => e.currentTarget.style.background = headerHover}
        onMouseLeave={e => e.currentTarget.style.background = headerBg}
      >
        <div className="flex items-center gap-4 flex-wrap">
          <span className="w-8 h-8 rounded-full text-white text-sm font-bold flex items-center justify-center flex-shrink-0"
            style={{ background: numBg }}>{section.number}</span>
          <h2 className="text-lg font-bold text-gray-800">{section.title}</h2>
          {isAge      && <AgeBadge />}
          {isLiability && <CriticalBadge />}
        </div>
        <span className={`text-xl transition-transform duration-200 flex-shrink-0 ml-3 ${open ? "rotate-180" : ""}`}
          style={{ color: chevronCol }}>▾</span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height:0, opacity:0 }} animate={{ height:"auto", opacity:1 }} exit={{ height:0, opacity:0 }}
            transition={{ duration:0.25, ease:"easeInOut" }} style={{ overflow:"hidden" }}>
            <div className="px-6 py-5 bg-white">
              {section.content && <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{section.content}</p>}
              {section.subsections && section.subsections.map((sub, i) => {
                const subIsAge  = sub.title.toLowerCase().includes("age") || sub.title.toLowerCase().includes("minor") || sub.title.toLowerCase().includes("coppa");
                const subIsEmerg= sub.title.toLowerCase().includes("emergency");
                return (
                  <div key={i} className="mb-5 last:mb-0 rounded-xl" style={
                    subIsAge && sub.highlight      ? { background:"#fff5f5", borderLeft:"4px solid #dc2626",  paddingLeft:16, paddingRight:12, paddingTop:12, paddingBottom:12 }
                    : subIsEmerg && sub.highlight  ? { background:"#fffbeb", borderLeft:"4px solid #f59e0b",  paddingLeft:16, paddingRight:12, paddingTop:12, paddingBottom:12 }
                    : sub.highlight                ? { background:"#fdf8f5", borderLeft:"4px solid #967d6c",  paddingLeft:16, paddingRight:12, paddingTop:12, paddingBottom:12 }
                    : {}
                  }>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8, flexWrap:"wrap" }}>
                      <h3 className="text-sm font-bold text-gray-800">{sub.title}</h3>
                      {subIsAge   && <span style={{ padding:"1px 8px", borderRadius:99, background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.22)", fontSize:9, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#dc2626" }}>Required</span>}
                      {subIsEmerg && <span style={{ padding:"1px 8px", borderRadius:99, background:"rgba(245,158,11,0.10)", border:"1px solid rgba(245,158,11,0.28)", fontSize:9, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#d97706" }}>⚡ Critical</span>}
                    </div>
                    <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{sub.content}</p>
                  </div>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const TermsAndConditions = () => (
  <>
    <Helmet>
      <title>Terms and Conditions — Furbabies.AI</title>
      <meta name="description" content="Read the Furbabies.AI Terms and Conditions of Service." />
    </Helmet>
    <Navbar />
    <div className="min-h-screen bg-white pt-28 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <motion.div initial={{ opacity:0, y:30 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.7 }}
          className="mb-12 text-center mt-20">
          <p className="text-[#967d6c] font-semibold poppins-text text-sm uppercase tracking-widest mb-3">Legal</p>
          <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 mb-4">Terms & Conditions</h1>
          <p className="poppins-text text-gray-500 text-sm">Effective Date: March 10, 2026 &nbsp;·&nbsp; Last Updated: March 10, 2026</p>
          <div className="mt-4 inline-block bg-[#fdf8f5] border border-[#e8ddd6] rounded-full px-5 py-2">
            <p className="text-xs poppins-text text-gray-500">
              Furbabies Inc. · 495 Grand Blvd #206, Miramar Beach, FL 32550 ·{" "}
              <a href="mailto:social@furbabies.ai" className="text-[#967d6c] hover:underline">social@furbabies.ai</a>
            </p>
          </div>
        </motion.div>

        {/* General notice */}
        <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.3, duration:0.6 }}
          className="mb-5 rounded-2xl px-6 py-5" style={{ background:"#967d6c", color:"white" }}>
          <p className="text-sm font-semibold leading-7">
            PLEASE READ THESE TERMS CAREFULLY. BY USING THIS SERVICE YOU AGREE TO BINDING ARBITRATION, A CLASS ACTION WAIVER, A ONE-YEAR LIMITATIONS PERIOD, AND A COMPLETE RELEASE OF LIABILITY FOR PET HARM. SEE SECTIONS 7 AND 12.
          </p>
        </motion.div>

        {/* 18+ age gate banner */}
        <motion.div initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.45, duration:0.55 }}
          className="mb-5 rounded-2xl px-6 py-5"
          style={{ background:"linear-gradient(135deg,#fff5f5,#fef2f2)", border:"1.5px solid rgba(220,38,38,0.35)", boxShadow:"0 4px 20px rgba(220,38,38,0.08)" }}>
          <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
            <div style={{ width:40, height:40, borderRadius:10, background:"#dc2626", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>🔞</div>
            <div>
              <p style={{ fontSize:13, fontWeight:800, color:"#dc2626", letterSpacing:"0.06em", textTransform:"uppercase", marginBottom:6 }}>Age Restriction — 18+ Only</p>
              <p style={{ fontSize:14, color:"#7f1d1d", lineHeight:1.72, margin:0 }}>
                <strong>THE SERVICE IS STRICTLY FOR USERS 18 YEARS OF AGE OR OLDER.</strong> By accessing Furbabies.AI you represent you are at least 18. We do not knowingly collect data from minors. If you are under 18, you must not use this Service. See <strong>Section 3</strong> for full age terms, verification rights, and COPPA compliance details.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Emergency banner */}
        <motion.div initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.55, duration:0.55 }}
          className="mb-8 rounded-2xl px-6 py-5"
          style={{ background:"linear-gradient(135deg,#fffbeb,#fef9e7)", border:"1.5px solid rgba(245,158,11,0.40)", boxShadow:"0 4px 20px rgba(245,158,11,0.07)" }}>
          <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
            <div style={{ width:40, height:40, borderRadius:10, background:"#f59e0b", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>🚨</div>
            <div>
              <p style={{ fontSize:13, fontWeight:800, color:"#92400e", letterSpacing:"0.06em", textTransform:"uppercase", marginBottom:6 }}>Not an Emergency Service</p>
              <p style={{ fontSize:14, color:"#78350f", lineHeight:1.72, margin:0 }}>
                <strong>IF YOUR PET IS IN DISTRESS, DO NOT USE THIS APP.</strong> Contact an emergency veterinarian immediately. This Service cannot diagnose emergencies or replace professional veterinary care. See <strong>Section 5.3</strong>.
              </p>
            </div>
          </div>
        </motion.div>

        {sections.map((section, i) => <SectionBlock key={i} section={section} index={i} />)}

        {/* Report underage CTA */}
        <motion.div initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}
          className="mt-8 mb-8 rounded-2xl px-6 py-5" style={{ background:"#fff5f5", border:"1px solid rgba(220,38,38,0.25)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <div style={{ fontSize:22 }}>👨‍👩‍👧</div>
            <div style={{ flex:1, minWidth:200 }}>
              <p style={{ fontSize:13, fontWeight:700, color:"#dc2626", marginBottom:4 }}>Parent or Guardian?</p>
              <p style={{ fontSize:13, color:"#6b7280", lineHeight:1.65, margin:0 }}>If you believe your child under 18 has accessed this Service, contact us immediately to remove their account and all associated data.</p>
            </div>
            <a href="mailto:social@furbabies.ai?subject=Minor Account Report"
              style={{ display:"inline-block", padding:"10px 20px", borderRadius:10, background:"#dc2626", color:"white", fontSize:13, fontWeight:700, textDecoration:"none", whiteSpace:"nowrap", flexShrink:0 }}>
              Contact Us →
            </a>
          </div>
        </motion.div>

        <motion.div initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}
          className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { label:"Privacy Policy", to:"/privacy-policy", desc:"How we collect and use your data" },
            { label:"Cookie Policy",  to:"/cookie-policy",  desc:"How we use cookies and tracking" },
          ].map(item => (
            <Link key={item.to} to={item.to}
              className="flex items-center justify-between bg-[#f4ede7] hover:bg-[#ede4db] transition-colors rounded-2xl px-6 py-4 group">
              <div>
                <p className="font-bold text-gray-800 text-sm">{item.label}</p>
                <p className="text-xs text-gray-500 poppins-text mt-0.5">{item.desc}</p>
              </div>
              <span className="text-[#967d6c] text-lg group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          ))}
        </motion.div>
      </div>
    </div>
    <Footer />
  </>
);

export default TermsAndConditions;